<template>
  <transition name="el-fade-in-linear">
  <div v-show="transitionshow">  
	  
	  <el-form :inline="true" class="demo-form-inline backborder1" size="small">
          <el-form-item>
	          <el-select v-model="deposit.type" placeholder="请选择分类">
	              <el-option label="不选分类" value="0"></el-option>
	              <el-option label="订单结算" value="1"></el-option>
	              <el-option label="客户结清欠款" value="2"></el-option>
	              <el-option label="订单部分退款" value="3"></el-option>
	              <el-option label="订单全部退款" value="4"></el-option>
	              <el-option label="预存款充值" value="5"></el-option>
	          </el-select>
          </el-form-item>
	      <el-form-item>
	          <el-date-picker v-model="deposit.date" type="daterange" width="290px" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
		      </el-date-picker>
	      </el-form-item>
	      <el-form-item>
	          <el-button type="primary" icon="el-icon-search" @click="getdeposit">查询</el-button>
	      </el-form-item>
	      <el-form-item>
              <el-button type="primary" icon="el-icon-circle-plus-outline"  @click="adddeposit">充值</el-button>
          </el-form-item>
          <el-form-item>
           	  <el-tag type="danger" style="padding:0 10px 33px 10px;line-height:32px">剩余预存款：￥{{depositbalance}}</el-tag>
          </el-form-item>
	  </el-form>
	        
	  <div class="backborder2" style="margin-top:10px"> 
	      <el-table :data="depositlists" v-loading="depositLoading" style="width:100%">
	          <el-table-column label="单号" prop="sn" width="150"></el-table-column>
	          <el-table-column label="客户名称" prop="customername" width="230"></el-table-column>
	          <el-table-column label="类型" prop="type" width="160"></el-table-column>
              <el-table-column label="金额" width="120">
	              <template slot-scope="scope">
					  <span v-if="scope.row.total>=0" style="color:#67C23A">{{scope.row.total}}</span>
					  <span v-if="scope.row.total<0" style="color:#F56C6C">{{scope.row.total}}</span>
	              </template>
              </el-table-column>
	          <el-table-column label="备注" prop="node" width="180"></el-table-column>
	          <el-table-column label="时间" prop="inputtime" align="center"></el-table-column>
          </el-table>            
          <div class="block">
	          <!--分页begin-->
	          <el-pagination
		          @size-change="depositSizeChange"
		          @current-change="depositCurrentChange"
		          :current-page="deposit.p"
		          :page-sizes="[10, 20, 50]"
		          :page-size="deposit.rollpage"
		          layout="total, sizes, prev, pager, next, jumper"
		          :total="deposit_total_rows">
	          </el-pagination>
	          <!--分页end-->
          </div>
	  </div>
	  
	  <!------------------------添加预存款 start---------------------->
      <el-dialog title="添加预存款" :visible.sync="addpositDialog" width="23%" top="20vh">
          <el-form :inline="true" class="demo-form-inline">
        	  <el-col :span="22">
	              <el-form-item label="金额">
	                  <el-input v-model="savedeposit.balance"></el-input>
	              </el-form-item>
              </el-col>
              <el-col :span="22">
	              <el-form-item label="备注">
	                  <el-input type="textarea" v-model="savedeposit.node" rows="4"></el-input>
	              </el-form-item>
              </el-col>
          </el-form>
          <div slot="footer" class="dialog-footer">
	          <el-button size="small" @click="addpositDialog = false">取 消</el-button>
	          <el-button size="small" type="primary" :loading="addpositLoading" @click="depositSave">保 存</el-button>
          </div>
      </el-dialog>
      <!------------------------添加预存款 end------------------------>
	  
  </div>
  </transition>
</template>

<script>

export default {
  props:['childdata'],
  data () {
    return {
      actionauth:'', //操作权限
      transitionshow:true,
      url:this.GLOBAL.domain+"Customer/index",
      deposit: {
      	  act:'depositlog',
      	  token:this.$cookies.get('token'),
      	  date:[],
      	  type:'',
      	  customerid:'',
      	  p: 1,
      	  rollpage: 10,
      },
      depositbalance:0.00,
      depositlists:[],
      depositLoading:false,
      deposit_total_rows:0,
      addpositDialog:false,
      addpositLoading:false,
      savedeposit: {
      	  act:'adddeposit',
      	  token:this.$cookies.get('token'),
      	  balance:0.00,
      	  customerid:'',
      	  node:'',
      },
      
    }
  },
  mounted(){
      this.getactionauth();
      this.deposit.customerid=this.childdata.id;
      this.savedeposit.customerid=this.childdata.id;
      this.depositbalance=this.childdata.balance;
      this.getdeposit();
  },
  methods:{  
  	//重置表单
    reset() {
        this.$refs.create.resetFields();
    },
	
	/** 获取操作权限 **/
  	getactionauth() {
    	var data =this.$cookies.get('actionauth');
    	data=JSON.parse(data);
        this.actionauth=data;
    },
    
    /** 获取客户预存款记录 **/
    getdeposit() {
    	this.depositLoading=true;      
        var resource = this.$resource(this.url);
    	resource.query(this.deposit).then((res) => {
	        if(res.data.Result>0){
	          if(res.data.Result=='70001') this.$router.push('/login')
	          this.$message.error(res.data.Message);
	          this.depositLoading=false;
	        }else{
	          this.depositlists=JSON.parse(Base64.decode(res.data.Data));
	          this.deposit_total_rows=parseInt(res.data.count);
	          this.depositLoading=false;
	        }
        }).catch((res) => {
            this.depositLoading=false;
        });
    },
    
    /** 预存款充值 **/
    adddeposit() {
    	this.addpositDialog=true;
    },
    
    depositSizeChange(val) {
        this.depositrollpage = val;
        this.getdeposit();
    },
    depositCurrentChange(val) {
        this.deposit.p = val;
        this.getdeposit();
    },
    
    /** 添加预存款 **/
    depositSave() {
    	this.addpositLoading=true;
    	var resource = this.$resource(this.url);
        resource.save(this.savedeposit).then((res) => {
        	if(res.data.Result>0){
            	if(res.data.Result=='70001') this.$router.push('/login');
            	this.addpositLoading=false;
                this.$message.error(res.data.Message);
            }else{
            	this.addpositLoading=false;
            	this.addpositDialog=false;
            	this.getdeposit();
            	this.depositbalance=res.data.Message;
            	this.$message.success('预存款添加成功！');
            }
        }).catch((res) => {
        	this.addpositLoading=false;
        });
    },
    
    
  }
}
</script>
<style type="text/css">
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:0 1% 3% 1%}
</style>


// WEBPACK FOOTER //
// src/components/base/Customerdeposit.vue